import moment from "moment"

export const makeMomentDate = (date, format) =>
  moment(new Date(date)).format(format)
